/**
 * Persistence helpers for the /b2b/* onboarding tour.
 * Bumping ONBOARDING_VERSION will re-show the tour to existing users.
 */
const STORAGE_KEY = 'b2b-onboarding-seen';

export const ONBOARDING_VERSION = '1';

export function isOnboardingSeen() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === ONBOARDING_VERSION;
  } catch {
    return false;
  }
}

export function markOnboardingSeen() {
  try {
    window.localStorage.setItem(STORAGE_KEY, ONBOARDING_VERSION);
  } catch { /* storage may be disabled */ }
}

export function resetOnboarding() {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch { /* ignore */ }
}
